// ======================================================================
// File Name       : SelectServiceUserDialog
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm, getFormValues, change } from 'redux-form';
import { RETURN_MAX_NUM } from '../../../constants';
import * as groupActions from '../../../actions/GroupAction';
import * as courseActions from '../../../actions/CourseAction';
import * as MessageTemplate from '../../../constants/MessageTemplate';
import * as csvDownloadAction from '../../../actions/csvDownloadAction';
import ModalWrapper from '../../../components/modal/ModalWrapper';
import SearchUser from './SearchUser';
import UserList from './UserList';
import SelectedUserList from './SelectedUserList';
import SelectGroupDialog from '../../SelectGroupDialog';
import MessageSearch from '../../../components/MessageSearch';
import * as UserHistoryStudentAction from '../../../actions/UserHistoryStudentAction';


class SelectServiceUserDialog extends Component {
  constructor(props) {
    super();
    this.state = {
      checkedUserList: [],
      checkedUserOnModal: [],
      show: false,
      isAllowShowSearchMessage: false,
    };
    this.onOK = this.onOK.bind(this);
    this.onCancel = this.onCancel.bind(this);
    this.getStartEndData = this.getStartEndData.bind(this);
    this.handleAddUser = this.handleAddUser.bind(this);
    this.handleCheckbox = this.handleCheckbox.bind(this);
    this.handleCheckAll = this.handleCheckAll.bind(this);
    this.handleRemoveUser = this.handleRemoveUser.bind(this);
    this.handleRemoveAll = this.handleRemoveAll.bind(this);
    this.handleShowGroupDlg = this.handleShowGroupDlg.bind(this);
    this.closeSelectGroupDialog = this.closeSelectGroupDialog.bind(this);
    this.handleSearchUserService = this.handleSearchUserService.bind(this);
    this.handleRemoveSelectedGroup = this.handleRemoveSelectedGroup.bind(this);
    this.dismissMessage = this.dismissMessage.bind(this);
  }

  componentWillMount() {
    this.props.dispatch(groupActions.removeSelectedGroup());
  }

  componentDidMount() {
    this.props.dispatch(csvDownloadAction.initServiceUserGroupList());
  }

  componentWillUnmount() {
    this.props.dispatch(groupActions.removeSelectedGroup());
    this.props.dispatch(csvDownloadAction.unMountUserDialog());
  }

  onOK() {
    const { addedUserList } = this.props;
    this.props.dispatch(csvDownloadAction.addCheckedUserToTargetList(addedUserList));
    this.props.hideModal();
  }

  onCancel() {
    this.props.dispatch(csvDownloadAction.resetUser());
    this.props.hideModal();
  }

  getStartEndData(startPosition) {
    const { invalid, formValues, userServiceSearchConditions } = this.props;
    if (invalid) return;
    const param = userServiceSearchConditions;
    this.props.dispatch(csvDownloadAction.searchUserService(param, startPosition));
  }

  /**
   * Handle Checkbox event
   */
  handleCheckbox(event) {
    const { value } = event.target;
    const checkedUserOnModal = [...this.state.checkedUserOnModal];
    const position = checkedUserOnModal.indexOf(value);
    position < 0 ? checkedUserOnModal.unshift(value) : checkedUserOnModal.splice(position, 1);
    this.setState({ checkedUserOnModal });
  }

  /**
   * Handle
   */
  handleAddUser() {
    const checkedUserOnModal = [...this.state.checkedUserOnModal];
    const checkedUserList = [...this.state.checkedUserOnModal];
    const addedList = checkedUserList;
    this.setState({ checkedUserList }, () => {
      this.props.dispatch(csvDownloadAction.addCheckedUserServiceToAddedList({ addedList: this.state.checkedUserList }));
    });
  }

  handleCheckAll() {
    const { targetUser, csvDownload } = this.props;
    const { checkedUserOnModal, checkedUserList } = this.state;
    const checkUserIdChecked = [];
    if (targetUser.allSecernIds && targetUser.allSecernIds.length) {
      targetUser.allSecernIds.map((userSecernId) => {
        const pos = checkedUserOnModal.indexOf(userSecernId);
        if (pos > -1) {
          checkUserIdChecked.push(pos);
        }
      });

      if (checkUserIdChecked.length === targetUser.allSecernIds.length) {
        // uncheck all
        targetUser.allSecernIds.map((userSecernId) => {
          const pos = checkedUserOnModal.indexOf(userSecernId);
          if (pos > -1) {
            checkedUserOnModal.splice(pos, 1);
          }
          return null;
        });
        this.setState({ checkedUserOnModal: [...checkedUserOnModal] });
        return;
      }
      // checkAll
      targetUser.allSecernIds.map((userSecernId) => {
        if (checkedUserList.indexOf(userSecernId) < 0) {
          checkedUserList.unshift(userSecernId);
        }
        return null;
      });
      this.setState({ checkedUserOnModal: [...checkedUserList], checkedUserList });
    }
  }

  handleRemoveUser(userSecernId) {
    const { checkedUserList, checkedUserOnModal } = this.state;
    const pos = checkedUserList.indexOf(userSecernId);
    if (pos >= 0) {
      checkedUserList.splice(pos, 1);
    }
    const pos2 = checkedUserOnModal.indexOf(userSecernId);
    if (pos2 >= 0) {
      checkedUserOnModal.splice(pos2, 1);
    }
    this.setState({
      checkedUserList, checkedUserOnModal,
    }, () => {
      this.props.dispatch(csvDownloadAction.addCheckedUserServiceToAddedList({ removedSecern: userSecernId }));
    });
  }

  handleRemoveAll() {
    this.setState({
      checkedUserList: [],
      checkedUserOnModal: [],
    }, () => {
      this.props.dispatch(csvDownloadAction.addCheckedUserServiceToAddedList({ removedAll: true }));
    });
  }

  handleShowGroupDlg() {
    this.setState({ show: true });
  }

  closeSelectGroupDialog() {
    this.setState({
      show: false,
    });
  }

  handleSearchUserService() {
    const {
      userName,
      loginId,
      userAttributeKeyNum,
      userAttributeSearchText,
      isDisplayHibernateUsers,
      selectedTargetGroup,
    } = this.props.formValues;

    const param = {
      userName,
      loginId,
      userAttributeKeyNum,
      userAttributeSearchText,
      isDisplayHibernateUsers,
      selectedTargetGroup,
    };
    this.props.dispatch(csvDownloadAction.searchUserService(param));
    this.props.change('startPosition', 0);
    this.setState({ isAllowShowSearchMessage: true });
  }

  handleRemoveSelectedGroup() {
    this.props.change('selectedTargetGroup', 'selecteServiceUserDialog', {});
    this.props.dispatch(groupActions.removeSelectedGroup());
  }

  dismissMessage() {
    this.setState({ isAllowShowSearchMessage: false });
  }

  getModalOptions() {
    return {
      title: '対象の受講ユーザーを指定してください',
      footerBtns: null,
    };
  }

  render() {
    const { targetUser } = this.props;
    const styleDialogSelectGroup = {
      background: 'none',
      width: 'auto',
      marginLeft: 0,
      left: 0,
      top: 30,
    };
    return (
      <ModalWrapper
        {...this.getModalOptions()}
        hideModal={this.props.hideModal}
      >
        <MessageSearch
          recordNum={targetUser ? targetUser.recordNum : 0}
          resultList={targetUser ? targetUser.allSecernIds : []}
          isAllowShowSearchMessage={this.state.isAllowShowSearchMessage}
          dismissMessage={this.dismissMessage}
        />
        <SearchUser
          handleShowGroupDlg={this.handleShowGroupDlg}
          handleSearchUserService={this.handleSearchUserService}
          handleRemoveSelectedGroup={this.handleRemoveSelectedGroup}
        />
        <UserList
          checkedUserOnModal={this.state.checkedUserOnModal}
          getStartEndData={this.getStartEndData}
          handleAddUser={this.handleAddUser}
          handleCheckbox={this.handleCheckbox}
          handleCheckAll={this.handleCheckAll}
        />
        <SelectedUserList
          handleRemoveUser={this.handleRemoveUser}
          handleRemoveAll={this.handleRemoveAll}
          onCancel={this.onCancel}
          onOK={this.onOK}
        />
        <SelectGroupDialog
          {...this.props.groupInfo}
          show={this.state.show}
          showSelectGroupDialog={this.showSelectGroupDialog}
          closeSelectGroupDialog={this.closeSelectGroupDialog}
          formKey="selecteServiceUserDialog"
          shouldSearchGroup={false}
          style={styleDialogSelectGroup}
        />

      </ModalWrapper>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { group, authed, course } = state;
  const { csvDownload } = state;
  const { targetUser, addedUserList, userServiceSearchConditions } = csvDownload;
  const { authedUser } = authed;
  const { userInfo } = authedUser;
  const { structures } = state.group;
  const formValues = getFormValues('selecteServiceUserDialog')(state);

  return {
    formValues,
    group,
    userInfo,
    course,
    targetUser,
    addedUserList,
    csvDownload,
    groupInfo: structures,
    initialValues: {
      userAttributeKeyNum: 1,
      selectedTargetGroup: {},
    },
    userServiceSearchConditions,
  };
};

export default connect(mapStateToProps)(reduxForm({
  form: 'selecteServiceUserDialog', // a unique identifier for this form
  touchOnChange: true,
})(SelectServiceUserDialog));
